import styled from "styled-components";

const Label = styled.label`
  display: flex;
  align-items: center;

  font-weight: 500;
  font-size: 14px;

  color: #525252;
`;

export default Label;
